export const NO_ACCESS_TOKEN_PRESENT_ON_INIT =
  'NO_ACCESS_TOKEN_PRESENT_ON_INIT';
export const RETRIEVE_USER_INFORMATION_ON_INIT_PENDING =
  'RETRIEVE_USER_INFORMATION_ON_INIT_PENDING';
export const RETRIEVE_USER_INFORMATION_ON_INIT_SUCCESS =
  'RETRIEVE_USER_INFORMATION_ON_INIT_SUCCESS';
export const RETRIEVE_USER_INFORMATION_ON_INIT_FAILURE =
  'RETRIEVE_USER_INFORMATION_ON_INIT_FAILURE';
